import { type KeyboardEvent } from 'react'
import { observer } from 'mobx-react-lite'
import { type Observable } from 'rxjs'
import { type BoolQuestionAnswerEditorViewModel } from '@/features/jobs/questions/bool/BoolQuestionAnswerEditorViewModel'
import { BoolSelectQuestionAnswerEditor } from '@/features/jobs/questions/bool/components/BoolQuestionAnswerEditor'

export interface BoolSelectQuestionAnswerEditorContainerProps {
  editorVm: BoolQuestionAnswerEditorViewModel
  questionId: string
  isDisabled: boolean
  focus$?: Observable<unknown>
  onFocus?: () => unknown
  onEnterDown?: (e: KeyboardEvent) => unknown
}

export const BoolSelectQuestionAnswerEditorContainer = observer(
  function BoolSelectQuestionAnswerEditorContainer({
    editorVm,
    questionId,
    ...rest
  }: BoolSelectQuestionAnswerEditorContainerProps) {
    return (
      <BoolSelectQuestionAnswerEditor
        value={editorVm.isAnswered ? editorVm.textAnswer : undefined}
        onChange={editorVm.respond}
        testId={`bool-answer-${questionId}`}
        {...rest}
      />
    )
  },
)
